module.exports = __webpack_public_path__ + "static/lights3-5b71dfffcd0f2ba35eff4d2978efcb4d.jpg";